module.exports = __webpack_public_path__ + "fonts/antonio-regular-unhinted-webfont.69ca96c4.ttf";